const HeaderT1 = () => {
    const HeaderType1widget = document.querySelector(".header-type1-widget");
    if (HeaderType1widget) {
        const elementsToBeToggledArray = document.querySelectorAll("[data-to-be-overed]");
        const togglersArray = HeaderType1widget.querySelectorAll(".link-component");
        togglersArray.forEach(toggler => {
            if (toggler.innerHTML == "Vendita" || toggler.innerHTML == "Sale") {
                toggler.addEventListener("mouseover", () => {
                    elementsToBeToggledArray.forEach((element) => {
                        if (element.getAttribute("data-to-be-overed") == "0") {
                            element.classList.add("active");
                        }
                        else {
                            element.classList.remove("active");
                        }
                    });
                });
            }
            if (toggler.innerHTML == "Noleggio" || toggler.innerHTML == "Rent") {
                toggler.addEventListener("mouseover", () => {
                    elementsToBeToggledArray.forEach((element) => {
                        console.log("GET " + element.getAttribute("data-to-be-overed"));
                        if (element.getAttribute("data-to-be-overed") == "1") {
                            element.classList.add("active");
                        }
                        else {
                            element.classList.remove("active");
                        }
                    });
                });
            }
            if (toggler.innerHTML == "Design") {
                toggler.addEventListener("mouseover", () => {
                    elementsToBeToggledArray.forEach((element) => {
                        if (element.getAttribute("data-to-be-overed") == "2") {
                            element.classList.add("active");
                        }
                        else {
                            element.classList.remove("active");
                        }
                    });
                });
            }
        });
    }
};
